<template>
    <div>
        <div id="notificacionElectronicaAntiguo_div" class="w-100 px-5 py-4">
            <div id="tituloNotificacionElectronicaAntiguo_div">
                <h1>NOTIFICACIÓN ELECTRÓNICA</h1>
                <h3>Encargado de la notificación electrónica de acuerdos</h3>
            </div>
            <div id="contenidoNotificacionElectronicaAntiguo_div" class="d-flex row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xlg-3 padding-div-low">
                    <div class="area">
                        <h4>Búsqueda</h4>
                        <hr />
                        <div class="form-group" id="folioDelAcuerdo_div">
                            <label for="folioDelAcuerdo">Folio del acuerdo</label>
                            <input type="text" id="folioDelAcuerdo" class="form-control" placeholder="Ingrese el número de folio" v-model="folioDelAcuerdo" />
                        </div>
                        <div class="text-right">
                            <button class="btn btn-primary" id="realizarBusqueda_btn" @click='BuscaLosAcuerdosPorFolio()'>Realizar búsqueda</button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xlg-9 padding-div-low" v-if="acuerdoANotificar != null">
                <!-- <div class="col-9 padding-div-low" v-if="listadoDeAcuerdos.length > 0"> -->
                    <div class="area">
                        <div id="datosDelAcuerdo_div">
                            <h4>Acuerdo encontrado</h4>
                            <h6>Información básica</h6>
                            <hr />
                            <div class="col-12">
                                <div class="row">
                                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4" id="seleccionarDocumentoASubir_div">
                                        <label for="seleccionarDocumentoASubir">Folio</label>
                                        <input type="text" class="form-control" v-model="acuerdoANotificar.Ide_acue" disabled />
                                    </div>
                                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4" id="consecutivo_div">
                                        <label for="consecutivo">Consecutivo</label>
                                        <input type="text" id="consecutivo" class="form-control" v-model="acuerdoANotificar.Equita_Padre.Consecutivo_EQUITA" disabled />
                                    </div>
                                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4" id="anio_div">
                                        <label for="anio">Año</label>
                                        <input type="text" id="anio" class="form-control" v-model="acuerdoANotificar.Equita_Padre.Anio_EQUITA" disabled />
                                    </div>
                                    <div class="form-group col-12" id="extracto_div">
                                        <label for="extracto">Extracto</label>
                                        <textarea id="extracto" class="form-control" v-model="acuerdoANotificar.Ext_ract" disabled />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="datosNecesarios_div" v-if="!EstaVacioLosDatos(acuerdoANotificar)">
                            <br />
                            <h5>Datos necesarios</h5>
                            <hr />
                            <div class="col-12">
                                <div class="d-flex row">
                                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4" id="incluirDocumentoDelAcuerdo_div">
                                        <label for="incluirDocumentoDelAcuerdo">¿Incluir el documento del acuerdo?</label>
                                        <select id="incluirDocumentoDelAcuerdo" class="form-control" v-model="seIncluyeElDocumentoDelAcuerdo">
                                            <option value="true" selected>Si</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8 text-right" id="extracto_div">
                                        <br />
                                        <a class="btn btn-primary overwrapDeBotones" :href="DescargaElAcuerdo(acuerdoANotificar.Rut_fisi, acuerdoANotificar.Nom_plan)"><i class="fas fa-file-download"></i>&nbsp;&nbsp;Descargar el acuerdo</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="datosDePersonalidades_div" v-if="!EstaVacioLosDatos(acuerdoANotificar)">
                            <br />
                            <h5>Personalidades a notificar</h5>
                            <h6>Seleccione las personalidades que desea notificar</h6>
                            <hr />
                            <div id="contenidoNotificacionElectronicaAntiguo_tablaDePersonalidades_div" class="table-responsive col-12">
                                <table class="table table-striped table-light table-hover table-bordered" id="tablaDePersonalidades_table" >
                                    <thead class="thead-dark text-center">
                                        <tr>
                                            <th style="width: 30px;"></th>
                                            <th>Nombre completo</th>
                                            <th>Correo electrónico</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-justify">
                                        <tr v-if="acuerdoANotificar.Equita_Padre.Mails.length <= 0" class="text-center" >
                                            <td colspan="3">No existen registros de personalidades a notificar</td>
                                        </tr>
                                        <tr v-else v-for="correoANotificar in acuerdoANotificar.Equita_Padre.Mails" :key="correoANotificar.Ide_mail">
                                            <td class="text-center">
                                                <input type="checkbox" name="personalidaesANotificar" id="personalidaesANotificar" v-model="correoANotificar.SeNotificara" class="form-check-input" />
                                            </td>
                                            <td>
                                                {{correoANotificar.Persona.Nom_pers}}{{(correoANotificar.Persona.Ape_pate != null && correoANotificar.Persona.Ape_pate != undefined ? " " + correoANotificar.Persona.Ape_pate : "")}}{{(correoANotificar.Persona.Ape_mate != null && correoANotificar.Persona.Ape_mate != undefined ? " " + correoANotificar.Persona.Ape_mate : "")}}
                                            </td>
                                            <td>
                                                {{correoANotificar.Dir_mail}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div id="adjuntarNuevosArchivos_div" v-if="!EstaVacioLosDatos(acuerdoANotificar)">
                            <br />
                            <h5>Adjuntar nuevos archivos</h5>
                            <hr />
                            <div class="col-12">
                                <div class="row">
                                    <div class="form-group col-12" id="seleccionarDocumentoASubir_div">
                                        <label for="seleccionarDocumentoASubir">Documento a subir</label>
                                        <input type="file" id="seleccionarDocumentoASubir" class="form-control" v-on:change="AdjuntarArchivo($event)" accept="application/pdf" />
                                    </div>
                                    <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xlg-6" id="nombreDelDocumento_div">
                                        <label for="nombreDelDocumento">Nombre del documento</label>
                                        <input type="text" id="nombreDelDocumento" class="form-control" placeholder="Nombre del documento" v-model="archivo.Nombre" disabled />
                                    </div>
                                    <div class="text-right form-group col-12">
                                        <button class="btn btn-primary overwrapDeBotones" id="agregarDocumento_btn" @click='AgregarDocumentoAlListado()'><i class="fas fa-file-upload"></i>&nbsp;&nbsp;Agregar documento</button>
                                    </div>
                                </div>
                            </div>
                            <h6>Los documentos agregados a la tabla son los que se enviaran a las personalidades a notificar</h6>
                            <hr />
                            <div id="contenidoNotificacionElectronicaAntiguo_tablaDeAdjuntos_div" class="table-responsive col-12">
                                <table class="table table-striped table-light table-hover table-bordered" id="tablaDeAdjuntos_table">
                                    <thead class="thead-dark text-center">
                                        <tr>
                                            <th>Nombre completo</th>
                                            <th>Tamaño</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-justify">
                                        <tr v-if="archivosAEnviar.length <= 0" class="text-center" >
                                            <td colspan="4">No existen registros de nuevos archivos a enviar</td>
                                        </tr>
                                        <tr v-else v-for="archivoAEnviar in archivosAEnviar" :key="archivoAEnviar.Ide_NotificacionArchivo">
                                            <td>
                                                {{archivoAEnviar.NombreArchivo}}
                                            </td>
                                            <td class="text-center">
                                                {{archivoAEnviar.Tamano}} MB
                                            </td>
                                            <td class="text-center">
                                                <a style="color: red;" title="Quita el documento a subir." v-on:click="CancelarLaSubidaDelDocumento(archivoAEnviar.Ide_NotificacionArchivo)"><i class="far fa-times-circle"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div class="text-right form-group" v-if="!EstaVacioLosDatos(acuerdoANotificar)">
                            <button class="btn btn-success overwrapDeBotones" id="agregarDocumento_btn" @click='EnviarNotificacion()'><i class="fas fa-paper-plane"></i>&nbsp;&nbsp;Enviar notificación electrónica</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'

export default {
    data() {
        return {
            enumeraciones,
            folioDelAcuerdo: "",
            acuerdoANotificar: null,
            seIncluyeElDocumentoDelAcuerdo: true, 
            archivo: {
                Documento: null, 
                Nombre: ""
            },
            archivosAEnviar: []
        }
    }, 
    methods: {
        EstaVacioLosDatos: function(objeto) {
            return objeto === undefined || objeto === null || Object.keys(objeto).length === 0 ? true : false;
        },
        ValidaLaBusqueda: function() {
            if(this.folioDelAcuerdo === "" || this.folioDelAcuerdo == undefined || this.folioDelAcuerdo == null) {
                comun.mensajeDeAlerta("Ingrese un numero de folio para buscar.");
                return false;
            }

            return true;
        },
        BuscaLosAcuerdosPorFolio: function() {
            if(this.ValidaLaBusqueda()) {
                comun.SeEstaCargandoInformacion(true);

                const parametros = {
                    EsPrueba: enumeraciones.EsPrueba, 
                    FolioId: this.folioDelAcuerdo
                }
                
                axios.post(
                    api.conexion + api.EQUITAS.sistema.notificaciones.ObtenLosAcuerdosPorFolio,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false)
                    ).then(respuesta => {
                        if(respuesta.data.SiHayError){
                            console.log(respuesta);
                            this.LimpiaLaNotificacionElectronica();
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                        } else {
                            console.log(respuesta)
                            if(respuesta.data.Satisfactorio.includes('El acuerdo aun no ha sido publicado'))
                            {
                                if(confirm(respuesta.data.Satisfactorio))
                                    this.acuerdoANotificar = respuesta.data.Acuerdo;
                                else
                                    this.LimpiaLaNotificacionElectronica();
                            }else
                                this.acuerdoANotificar = respuesta.data.Acuerdo;
                        }

                        comun.SeEstaCargandoInformacion(false);
                    }
                    ).catch(excepcion => {
                        console.log(excepcion);
                        this.LimpiaLaNotificacionElectronica();
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                    });
            }
        }, 
        DescargaElAcuerdo: function(rutaDelAcuerdo, nombreDelAcuerdo) {
            return  api.conexion + api.Comun.funcion.DescargarArchivo + "?rutaDelArchivo=\\\\fscivil\\EQUITAS" + rutaDelAcuerdo + nombreDelAcuerdo;
        },
        AdjuntarArchivo: function(evento) {
            if(this.VerificaQueSeaElDocumentoCorrecto(evento.target.files[0].name, "pdf") == false) {
                comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo PDF.<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
                $("#seleccionarDocumentoASubir").val('');
                this.archivo.Documento = null;
                return;
            }
            
            if(evento.target.files.length > 0) {
                this.archivo.Documento = evento.target.files[0];
                this.archivo.Nombre = this.archivo.Documento.name;
            } else {
                $("#seleccionarDocumentoASubir").val('');
                this.archivo.Documento = null;
            }
        },
        VerificaSiEstanTodosLosDatosParaAdjuntar: function() {
            if (this.archivo.Documento == null) {
                comun.mensajeDeAlerta("Seleccione un documento PDF.", null, null);
                return false;
            }

            if (this.archivo.Nombre == null || this.archivo.Nombre == ""){
                comun.mensajeDeAlerta("Ingrese el nombre del documento a anexar.", null, null);
                return false;
            }

            return true;
        },
        AgregarDocumentoAlListado: function() {
            if(this.VerificaSiEstanTodosLosDatosParaAdjuntar()) {
                let indice = 0;

                this.archivosAEnviar.forEach(archivoAEnviar => {
                    if(archivoAEnviar.Ide_NotificacionArchivo < indice)
                        indice = archivoAEnviar.Ide_NotificacionArchivo;
                });

                indice--;

                this.archivosAEnviar.push({
                    Ide_NotificacionArchivo: indice, 
                    NombreArchivo: this.archivo.Nombre,
                    Documento: this.archivo.Documento, 
                    Tamano: (this.archivo.Documento.size / (1024*1024)).toFixed(4)
                });

                this.archivo = {
                    Documento: null, 
                    Nombre: ""
                };
                $("#seleccionarDocumentoASubir").val('');
            }
        },
        CancelarLaSubidaDelDocumento: function(Ide_NotificacionArchivo){
            let indice = -1;

            for(let i = 0; i < this.archivosAEnviar.length; i++){
                if(this.archivosAEnviar[i].Ide_NotificacionArchivo == Ide_NotificacionArchivo)
                    indice = this.archivosAEnviar[i].Ide_NotificacionArchivo;
            }

            this.archivosAEnviar.splice(indice, 1);
        },
        VerificaQueSeaElDocumentoCorrecto: function(nombre, extension) {
            const nombreCortado = nombre.split(".");
            let siEsUnDocumentoValido = false;

            if (nombreCortado[nombreCortado.length - 1].toLowerCase() === extension.toLowerCase())
                siEsUnDocumentoValido = true;

            return siEsUnDocumentoValido;
        }, 
        ValidaSiSePuedeNotificar: function() {
            let seHaSeleccionadoUnaPersonaANotificar = false;

            this.acuerdoANotificar.Equita_Padre.Mails.forEach(mail => {
                if(mail.SeNotificara == true)
                    seHaSeleccionadoUnaPersonaANotificar = true;
            })

            if (seHaSeleccionadoUnaPersonaANotificar == false) {
                comun.mensajeDeAlerta("Seleccione a una personalidad a notificar.", null, null);
                return false;
            }

            return true;
        },
        ConstruyeElAcuerdo: function() {
            let acuerdo = Object.assign({}, this.acuerdoANotificar);

            let indice = 0;

            acuerdo.Equita_Padre.Mails.forEach(mail => {
                if(mail.SeNotificara) {
                    indice--;

                    let notificacion = {
                        Ide_noti: indice, 
                        Acuerdo: {
                            Ide_acue: this.acuerdoANotificar.Ide_acue
                        },
                        NotificacionesArchivos: this.archivosAEnviar
                    };

                    acuerdo.Notificaciones.push(notificacion);   
                }
            })

            return acuerdo;
        },
        EnviarNotificacion: function() {
            if(this.ValidaSiSePuedeNotificar()) {
                comun.SeEstaCargandoInformacion(true);

                const parametros = {
                    EsPrueba: enumeraciones.EsPrueba, 
                    Acuerdo: this.ConstruyeElAcuerdo(), 
                    SeIncluyeElDocumentoDelAcuerdo: this.seIncluyeElDocumentoDelAcuerdo
                }

                let datosDelFormulario = new FormData();
                datosDelFormulario.append("Parametros", JSON.stringify(parametros))

                if (this.archivosAEnviar.length > 0) {
                    this.archivosAEnviar.forEach(archivoAEnviar => {
                        datosDelFormulario.append("ID_" + archivoAEnviar.Ide_NotificacionArchivo, archivoAEnviar.Documento);
                    })
                }
                
                axios.post(
                    api.conexion + api.EQUITAS.sistema.notificaciones.EnviaLosCorreoDeLaNotificacionElectronica,
                    datosDelFormulario,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true)
                    ).then(respuesta => {
                        if(respuesta.data.SiHayError){
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                        } else {
                            this.LimpiaLaNotificacionElectronica();
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        }

                        comun.SeEstaCargandoInformacion(false);
                    }
                    ).catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                    });
            }
        }, 
        LimpiaLaNotificacionElectronica: function() {
            this.acuerdoANotificar = null;
            this.seIncluyeElDocumentoDelAcuerdo = true;
            this.archivo = {
                Documento: null, 
                Nombre: ""
            };
            this.archivosAEnviar = [];
        }
    }
}
</script>

<style>
  .padding-div-low {
    padding-top: 40px;
  }

  a {
    cursor: pointer;
  }

  input[type=checkbox] {
      margin-left: 0;
      position: inherit;
  }

  tbody {
      color: black;
  }
</style>


// WEBPACK FOOTER //
// src/components/EQUITAS/Notificaciones/NotificacionElectronicaAntiguo/Index.vue